import anime from 'animejs/lib/anime.es.js';

export function anniversaryHistoryFunc() {
    let anniversaryHistory = $('#anniversaryHistory').length;
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms))

    if (anniversaryHistory) {
        $('#mainKv #imgBox').addClass('active');
        $('#mainKvTit').addClass('active');
        $('#mainKvLead').addClass('active');
        
        var flug = true;
        $(window).scroll(function () {
            if (flug) {
                flug = false;
                setTimeout(function () {
                    // ここに処理を書く

                    let fiftyFivePosition = $('.fiftyFive').offset().top;
                    let fiftyPosition = $('.fifty').offset().top;
                    let fortyPosition = $('.forty').offset().top;
                    let thirtyPosition = $('.thirty').offset().top;
                    let twentyPosition = $('.twenty').offset().top;
                    let tenPosition = $('.ten').offset().top;
                    let fivePosition = $('.five').offset().top;
                    let fade = $('.fade').offset().top;
                    
                    var scroll = $(window).scrollTop();

                    if (scroll > fiftyFivePosition) {
                        $('.historyListVertical').addClass('isShow');
                    }
                    
                    //fade in
                    $('.fade').each(function () {
                        var position = $(this).offset().top;
                        var scroll = $(window).scrollTop();
                        var windowHeight = $(window).height();
                        //scroll > position - 700

                        if (scroll > position - windowHeight + 50) {
                            $(this).addClass('active');
                            $(this).children('.card').addClass('active');
                        }
                    });
                    $('.chronology').each(function () {
                        var position = $(this).offset().top;
                        var scroll = $(window).scrollTop();
                        var windowHeight = $(window).height();
                        //scroll > position - 700

                        if (scroll > position - windowHeight + 50) {
                            wait(0)
                                .then(() => {
                                    $('.chronology01').addClass('active');
                                    return wait(500)
                                })
                                .then(() => {
                                    $('.chronology02').addClass('active');
                                    return wait(500)
                                })
                                .then(() => {
                                    $('.chronology03').addClass('active');
                                    return wait(500)
                                })
                        }
                    });
                    
                    //背景色の変更
                    var secArr = new Array();
                    var current = -1;
                    /* ここに背景色を順に記述する*/
                    var secColor = new Array('#F5FAFD', '#FFFDFE', '#FFFDFE', '#FFFCFA', '#FFFCFA', '#FFFCF5', '#FFFCF5', '#FAFFFD', '#FAFFFD', '#FCFDF9', '#ffffff');
                    
                    $('.historyBlock').each(function (i) {
                        secArr[i] = $(this).offset().top - 400;
                    });

                    function chengeBG(secNum) {
                        if (secNum != current) {
                            current = secNum;
                            $('.historyBox').css({
                                backgroundColor: secColor[current]
                            });
                        }
                    }
                    $(window).on('scroll', function () {
                        for (var i = secArr.length - 1; i >= 0; i--) {
                            if ($(window).scrollTop() > secArr[i]) {
                                chengeBG(i);
                                break;
                            }
                        }
                    });
                    
                    if (scroll > fivePosition - 400) {
                        $('.historyCount').removeClass('fix');
                        $('.twoDigits01').addClass('y01');
                        
                    } else if (scroll > tenPosition - 650) {
                        $('.twenty').removeClass('change');
                        $('.historyCount').addClass('fix');
                        $('.twoDigits01').addClass('y01');

                        $('.oneDigits01').removeClass('y02');
                        $('.oneDigits01').addClass('y01');
                        $('.twoDigits01').addClass('y01');

                    } else if (scroll > twentyPosition - 650) {
                        $('.twenty').addClass('change');

                        $('.oneDigits01').removeClass('y03');
                        $('.oneDigits01').addClass('y02');
                        $('.twoDigits01').addClass('y01');

                    } else if (scroll > thirtyPosition - 650) {
                        $('.twenty').removeClass('change');

                        $('.oneDigits01').removeClass('y04');
                        $('.oneDigits01').addClass('y03');
                        $('.twoDigits01').addClass('y01');

                    } else if (scroll > fortyPosition - 650) {
                        $('.fifty').removeClass('change');

                        $('.oneDigits01').removeClass('y05');
                        $('.oneDigits01').addClass('y04');
                        $('.twoDigits01').addClass('y01');

                    } else if (scroll > fiftyPosition - 650) {
                        
                        $('.fifty').addClass('change');
                        
                        $('.oneDigits01').addClass('y05');
                        $('.twoDigits01').removeClass('y02');
                        $('.twoDigits01').addClass('y01');

                    } else if (scroll > fiftyFivePosition - 650) {
                        $('.fifty').removeClass('change');
                        $('.historyCount').addClass('fix');

                        $('.oneDigits01').addClass('y05');
                        $('.twoDigits01').addClass('y02');

                    } else{
                        $('.oneDigits01').removeClass('y01 y02 y03 y04 y05');
                        $('.twoDigits01').removeClass('y01 y02');
                        
                        $('.historyCount').removeClass('fix');
                        $('.historyListVertical').removeClass('isShow');
                    }

                    flug = true;
                    return flug;
                }, 200);
            }
        });
    }
}